/**
 * The words for a mission's difficulty.
 *
 * `MISSION_DIFFICULTIES` in `@shared/protocol` is ids only, and there is no
 * i18n — so these are inline English, in one place rather than in each of the
 * two screens that says them. The picker offers them and the garage floor
 * repeats the chosen one; two copies of a table this small is exactly how the
 * dialog and the summary come to disagree about what was picked.
 *
 * **When the create route learns about missions**, a room will report its own
 * difficulty and these belong beside `MATCH_MODE_NAMES` in `@shared/protocol`,
 * where the arena browser can read them too. They are here rather than there
 * only because nothing on the wire carries a difficulty yet, and `@shared` is
 * the server's to widen.
 */
import type { MissionDifficulty } from '@shared/protocol';

export const MISSION_DIFFICULTY_NAMES: Readonly<Record<MissionDifficulty, string>> = {
  standard: 'Standard',
  hardened: 'Hardened',
  veteran: 'Veteran',
};

/** One line each, for the cards. What changes, not how it feels. */
export const MISSION_DIFFICULTY_BLURBS: Readonly<Record<MissionDifficulty, string>> = {
  standard: 'The mission as designed.',
  hardened: 'More of them, and they shoot straighter.',
  veteran: 'Everything they have.',
};
